import { render, staticRenderFns } from "./VaffField.vue?vue&type=template&id=a678ec94&scoped=true&"
import script from "./VaffField.vue?vue&type=script&lang=js&"
export * from "./VaffField.vue?vue&type=script&lang=js&"
import style0 from "./VaffField.vue?vue&type=style&index=0&id=a678ec94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a678ec94",
  null
  
)

export default component.exports